import React, { useState } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableRow, useToggle } from 'react-md'

import { Callout, ConfirmDialog, Modal } from 'components/core'
import { DeleteButton } from 'components/data-table'
import { CalloutType } from 'components/core/callout'

import { handleRemoveMaintenanceAction } from './actions'

import AddAction from './components/add'

interface ComponentProps {
  technicalVisitId: string
  technicalVisitEquipmentId: string | undefined
  equipmentId: string | undefined
  maintenanceActions: Array<any> | undefined
  visibleModal: boolean
  disableModal: () => void
  loadMaintenanceActions: () => Promise<void>
}

const Component: React.FC<ComponentProps> = ({
  technicalVisitId,
  technicalVisitEquipmentId,
  equipmentId,
  maintenanceActions,
  visibleModal,
  disableModal,
  loadMaintenanceActions,
}) => {
  const [actionId, setActionId] = useState<string | null>(null)
  const [visibleAdd, enableAdd, disableAdd] = useToggle(false)

  return (
    <>
      <Modal
        title={'Ações de Manutenção'}
        visible={visibleModal}
        confirmTitle={'Adicionar Ação de Manutenção'}
        confirmAction={async () => enableAdd()}
        closeTitle={'Fechar'}
        closeAction={async () => disableModal()}>
        {(!maintenanceActions || maintenanceActions.length == 0) && (
          <Callout text={'Nenhuma ação de manutenção localizada'} type={CalloutType.Info} />
        )}
        {maintenanceActions && maintenanceActions.length > 0 && (
          <TableContainer>
            <Table fullWidth>
              <TableBody>
                {maintenanceActions?.map((action, index) => (
                  <TableRow key={index}>
                    <TableCell grow>{action.label}</TableCell>
                    <TableCell align='right'>
                      <DeleteButton id='delete-action-button' action={() => setActionId(action.value)} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Modal>

      <AddAction
        technicalVisitId={technicalVisitId}
        technicalVisitEquipmentId={technicalVisitEquipmentId}
        equipmentId={equipmentId}
        visibleModal={visibleAdd}
        disableModal={disableAdd}
        loadMaintenanceActions={loadMaintenanceActions}
      />

      <ConfirmDialog
        text='Deseja realmente excluir a ação de manutenção? Essa ação não poderá ser desfeita'
        visible={actionId ? true : false}
        confirmAction={async () => {
          if (actionId) {
            if (technicalVisitEquipmentId && (await handleRemoveMaintenanceAction(technicalVisitId, technicalVisitEquipmentId, actionId))) {
              await loadMaintenanceActions()
              setActionId(null)
            }
          }
        }}
        cancelAction={async () => setActionId(null)}
      />
    </>
  )
}

export default Component
